import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import './group.css';
export const Group = ({ children, name, colour, open }) => {
    let [closed, setClosed] = useState(!open || false);
    const className = `group ${colour}`;
    return (_jsxs("div", { className: className, children: [_jsx("div", { className: 'groupHeader', onClick: () => setClosed(!closed), children: _jsx("h2", { children: name }) }), _jsx("div", { className: closed ? 'groups closed' : 'groups', children: children })] }));
};
